<template>
  <BaseModal ref="BaseModal" :destroyOnClose="false" @confirm="handleConfirm">
    <div class="report-design">
      <LeftRightBox :leftWidthDefault="400">
        <template slot="left">
          <SimpleTable
            ref="leftTable"
            table-code="reportDesignLeft"
            :showIndex="false"
            :columns="columns"
            :allowMultiSelect="false"
            :data="tableData"
            :menus="['查询', '插入', '批量删除']"
            :menusMergeAfter="menusMergeAfterLeft"
            @row-select="handleRowSelectLeft"
            @modify-data-change="handleModifyDataChangeLeft"
          />
        </template>
        <template slot="right">
          <div class="right">
            <SimpleTable
              table-code="reportDesignTop"
              :showIndex="false"
              :columns="columnsTop"
              :data="tableDataTop"
              @modify-data-change="handleModifyDataChangeTop"
            />
            <SimpleTable
              table-code="reportDesignBottom"
              :showIndex="false"
              :columns="columnsBottom"
              :data="tableDataBottom"
              @modify-data-change="handleModifyDataChangeBottom"
            />
          </div>
        </template>
      </LeftRightBox>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal/index.vue'
import SimpleTable from '@/components/SimpleTable/index.vue'
import LeftRightBox from '@/components/LeftRightBox/index.vue'
import { tableMixin } from '@/utils/tableMixin'
import { sortRecords } from '@/utils/index'

function disableCondition(column, record, row) {
  return record.row > 2
}

export default {
  name: 'ReportDesign',
  components: { BaseModal, SimpleTable, LeftRightBox },
  mixins: [tableMixin],
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      columns: [
        {
          field: 'name',
          title: '报表名称',
          width: 300,
          canEdit: true,
          canModify: true
        }
      ],
      columnsTop: [
        {
          field: 'name',
          title: '维度数量',
          width: 120,
          canEdit: true,
          canModify: true
        },
        {
          field: 'horizontalSetting',
          title: '水平设计',
          width: 70,
          cellType: 'checkbox',
          disableCondition,
          canEdit: true
        },
        {
          field: 'checkFlag',
          title: '垂直设置',
          width: 70,
          cellType: 'checkbox',
          canEdit: true
        }
      ],
      columnsBottom: [
        { field: 'name', title: '数据内容', width: 200 },
        {
          field: 'checkFlag',
          title: '水平设置',
          width: 80,
          cellType: 'checkbox',
          canEdit: true
        }
      ],

      tableDataTop: [],
      tableDataBottom: []
    }
  },
  methods: {
    // 页面方法
    async show(options = {}) {
      this.options = { ...options }
      this.tableData = []
      this.tableDataTop = []
      this.tableDataBottom = []
      this.init()
      this.$refs.BaseModal.show(
        JSON.parse(
          JSON.stringify({
            title: '报表设计',
            width: '800px',
            showConfirm: true,
            confirmText: '生成报表'
          })
        )
      )
    },

    init() {
      this.getData()
    },
    async getData() {
      const res = await this.$service.get('/costAnalysisSetting/queryList', {
        type: this.type
      })
      this.tableData = sortRecords(res?.data || [])
      this.$refs.leftTable.initialized()
    },

    async handleRowSelectLeft(rows) {
      const selectedRecord = rows[0]
      if (
        this.currentSelectedRow === selectedRecord[0].originData &&
        this.tableDataTop.length
      )
        return
      this.currentSelectedRow = selectedRecord[0].originData
      const res = await this.$service.get('/costAnalysisSetting/getOne', {
        id: selectedRecord[0].originData.id
      })
      res.data?.verticalSetting.forEach(e => {
        e.horizontalSetting = false
      })

      const obj = res.data?.verticalSetting.find(
        e => e.fieldName === res.data.horizontalSetting
      )
      if (obj) obj.horizontalSetting = true

      this.tableDataTop = res.data?.verticalSetting
      this.tableDataBottom = res.data?.dataSetting
    },

    menusMergeAfterLeft(map) {
      map['插入'] = () => this.handleInsertLeft()
    },

    async handleInsertLeft() {
      const res = await this.$service.get('/costAnalysisSetting/getOne')
      const row = res.data || {}
      row.verticalSetting.forEach((e, i) => {
        e.horizontalSetting = i === 0
        e.checkFlag = i === 0
      })
      row.horizontalSetting = row.verticalSetting[0].fieldName
      this.$refs.leftTable.handleInsert([row])
    },

    refresh() {},

    async handleModifyDataChangeLeft(getModifyData, cleanModifyData) {
      const arr = getModifyData()
      if (!arr.length) return

      cleanModifyData()
      const id = await this.save({
        ...arr[0],
        verticalSetting: arr[0].id ? this.tableDataTop : arr[0].verticalSetting,
        dataSetting: arr[0].id ? this.tableDataBottom : arr[0].dataSetting
      })
      if (!arr[0].id) arr[0].id = id

      const sele = this.$refs.leftTable.getSelectData()
      if (!sele.length) {
        this.tableDataTop = []
        this.tableDataBottom = []
      }
    },

    async handleModifyDataChangeTop(getModifyData, cleanModifyData) {
      const arr = getModifyData()
      if (!arr.length) return
      const index = this.tableDataTop.findIndex(
        e => e.fieldName === arr[0].fieldName
      )
      if (index < 2) {
        if (
          this.tableDataTop[0].horizontalSetting ===
          this.tableDataTop[1].horizontalSetting
        )
          this.tableDataTop[index === 0 ? 1 : 0].horizontalSetting =
            !arr[0].horizontalSetting
      }
      this.currentSelectedRow.horizontalSetting = this.tableDataTop.find(
        e => e.horizontalSetting
      ).fieldName
      cleanModifyData()
      await this.save({
        ...this.currentSelectedRow,
        verticalSetting: this.tableDataTop,
        dataSetting: this.tableDataBottom
      })
    },

    async handleModifyDataChangeBottom(getModifyData, cleanModifyData) {
      const arr = getModifyData()
      if (!arr.length) return
      cleanModifyData()
      await this.save({
        ...this.currentSelectedRow,
        verticalSetting: this.tableDataTop,
        dataSetting: this.tableDataBottom
      })
    },

    async save(row) {
      const url = !row.id
        ? '/costAnalysisSetting/saveCostAnalysisSettingName'
        : '/costAnalysisSetting/save'
      const res = await this.$service.post(url, { ...row, type: this.type })
      if (res.code === 200) {
        if (!row.id && res.data) row.id = res.data
        this.$message.success('保存成功')
        return res.data
      }
    },

    handleConfirm(close) {
      const sele = this.$refs.leftTable.getSelectData()
      if (!sele?.length) {
        this.$message.warning('请先选中要生成报表的报表！')
        return
      }
      this.options.reportView(this.currentSelectedRow)
      close()
    }
  }
}
</script>

<style scoped lang="less">
.report-design {
  height: 420px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  .btns {
    margin-bottom: 12px;
  }
  .right {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    overflow: hidden;
    gap: 12px;
  }
}
</style>
